export default __webpack_public_path__ + "static/media/wallet-icon.90d4907c.svg";